import React from "react";
import { Redirect } from "react-router";
import { localUser, isTokenExpired } from "../../../assets/Helpers";

const AdminRoute = ({ component: Component, ...rest }) => {
  const user = localUser();

  // Check if user is logged in and token is valid
  if (!user || isTokenExpired(user.AUTHTOKEN)) {
    return <Redirect to="/admin/login" />;
  }

  // TODO: Add role check here if you have admin roles
  // if (user.role !== 'admin') {
  //   return <Redirect to="/" />;
  // }

  return <Component {...rest} />;
};

export default AdminRoute;

